import { ThemeTextColor } from '@rover/kibble/styles';
import roverTheme from '@rover/kibble/themes/roverTheme';

export enum IconBlockVariant {
  DEFAULT = 'default',
  SUCCESS = 'success',
  CAUTION = 'caution',
  ERROR = 'error',
}

// from https://bobbyhadz.com/blog/typescript-convert-enum-to-union
export type IconBlockVariants = `${IconBlockVariant}`;

export const TITLE_COLOR_FOR_VARIANT: Record<IconBlockVariant, ThemeTextColor> = {
  [IconBlockVariant.DEFAULT]: 'primary',
  [IconBlockVariant.SUCCESS]: 'success',
  [IconBlockVariant.CAUTION]: 'caution',
  [IconBlockVariant.ERROR]: 'error',
};

export const getIconColors = (theme: typeof roverTheme): Record<IconBlockVariant, string> => ({
  [IconBlockVariant.DEFAULT]: theme.textColor.primary.toString(),
  [IconBlockVariant.SUCCESS]: theme.textColor.success.toString(),
  [IconBlockVariant.CAUTION]: theme.textColor.caution.toString(),
  [IconBlockVariant.ERROR]: theme.textColor.error.toString(),
});
